import { Component, OnInit } from "@angular/core";
import { CommonService } from "../service/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FileUploadService } from "../service/fileupload.service";
import { UsersService } from "../service/users.service";

@Component({
  selector: "app-kekka-upload",
  templateUrl: "./kekka-upload.component.html",
  styleUrls: ["./kekka-upload.component.css"],
})
export class KekkaUploadComponent implements OnInit {
  constructor(
    public commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private fileUploadService: FileUploadService
  ) {}

  isLoaded: boolean = false;
  datalist: any = [];

  personId: number | null = null;
  uploadFile = null;

  ngOnInit(): void {
    this.personId = +this.route.snapshot.paramMap.get("tpid");
    this.getFileUploadData();
    window.scrollTo(0, 0);
  }

  updateUploadFile(file: File | null, row: any) {
    console.log(file);
    this.uploadFile = file;
    this.uploadSaikenFile(row);
  }

  getFileUploadData() {
    let param = {
      t_person_id: this.personId,
    };
    this.fileUploadService.getFileUploadList(param).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.datalist = res["fuel_results"]["data"];
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }

  getSaikenFile(row: any): void {
    let param = {
      t_saiken_file_id: row.id,
    };
    this.usersService.checkSingin().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(null, (modalresult) => {});
        } else {
          this.fileUploadService.downloadSaikenFile(param).subscribe({
            next: (res: any) => {
              const blob = res.body as Blob;

              // ファイル名（サーバがContent-Dispositionを返すならそこから取るのが理想）
              const filename = "download.pdf";

              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(url);
            },
            error: async (error) => {
              this.commonService.modalOpens(11003, (modalresult) => {});
            },
          });
        }
      },
      (error) => {
        this.commonService.modalOpens(11003, (modalresult) => {});
      }
    );
  }

  getSaikenUploadFile(row: any): void {
    let param = {
      t_saiken_upload_file_id: row.saiken_upload_file.id,
    };
    this.usersService.checkSingin().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(null, (modalresult) => {});
        } else {
          this.fileUploadService.downloadSaikenUploadFile(param).subscribe({
            next: (res: any) => {
              const blob = res.body as Blob;

              // ファイル名（サーバがContent-Dispositionを返すならそこから取るのが理想）
              const filename = "download.pdf";

              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(url);
            },
            error: async (error) => {
              this.commonService.modalOpens(11003, (modalresult) => {});
            },
          });
        }
      },
      (error) => {
        this.commonService.modalOpens(11003, (modalresult) => {});
      }
    );
  }

  uploadSaikenFile(row: any): void {
    const fd = new FormData();
    fd.append("file", this.uploadFile, this.uploadFile.name);
    fd.append(
      "t_saiken_upload_file_id",
      row.saiken_upload_file == null ? null : row.saiken_upload_file.id
    );
    fd.append("t_saiken_file_id", row.id);
    fd.append("t_person_id", row.t_person_id);

    this.fileUploadService.uploadSaikenFile(fd).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          const index = this.datalist.findIndex((data: any) => {
            return data["id"] == res["fuel_results"]["id"];
          });
          this.datalist[index] = res["fuel_results"];
          this.commonService.modalOpens(
            "アップロードが完了しました。",
            (modalresult) => {}
          );
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {
          this.getFileUploadData();
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/b0105-kekka-upload/kekka-upload.component.ts